<template>

    <Toast/>

    <MenuSiModuleMain/>
<!--    <HeadingOverviewDashboard/>-->

    <div class="px-6 surface-overlay relative">

        <div class="col-12 md:col-12">
            <div class="card p-fluid">

                <h2>Hello {{ this.profile.firstName }}</h2>

                <br/>

            </div>
        </div>

        <div v-show="activeTab === 1" class="grid">
            <div class="col-12">
                <div class="card p-fluid">
                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callHelp" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-question-circle mr-2"></i>
                                    <span>Help</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callSupport" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-info-circle mr-2"></i>
                                    <span>Contact Support</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <DataTable
                        :value="stocks"
                        :scrollable="true" scrollHeight="500px" scrollDirection="both"
                        :loading="loading"
                        :striped-rows="true"
                        :reorderableColumns="true"
                        :rowHover="true"
                        :globalFilterFields="['exchange', 'code', 'name']"
                        v-model:filters="filters"
                        dataKey="id"
                        class="p-datatable-gridlines">

                        <template #header>
                            <div class="col-12">
                                <div class="card p-fluid">
                                    <div class="grid">
                                        <div class="col-12 lg:col-6 p-3">
                                            <span class="p-input-icon-left">
                                            <i class="pi pi-search"/>
                                            <InputText v-model="filters['global'].value"
                                                       placeholder="Keyword Search on Exchange, Symbol or Name"
                                                       style="width: 100%" maxlength="20"/>
                                            </span>
                                        </div>

                                        <div class="col-12 lg:col-2 p-3">
                                            <Dropdown
                                                v-model="selectedExchange"
                                                :options="exchanges"
                                                optionLabel="name"
                                                optionValue="code"
                                                placeholder="Select an Exchange"
                                                @change="onExchangeChange"/>
                                        </div>

                                    </div>

                                </div>

                            </div>

                        </template>


                        <template #empty>
                            No stocks found.
                        </template>

                        <template #loading>
                            Loading stocks. Please wait.
                        </template>

                        <Column field="selectAnOption" style="max-width: 150px; min-width: 150px" frozen>
                            <template #body="{ data }">
                                <Button v-tooltip="'Stock History'" icon="pi pi-pencil"
                                        class="p-button-rounded p-button-success m-1"
                                        @click="callStockHistory(data)"/>

                                <Button v-tooltip="'Stock Data'" icon="pi pi-eye"
                                        class="p-button-rounded p-button-info m-1"
                                        @click="callStockData(data)"/>
                            </template>
                        </Column>

                        <Column field="code" header="Code" style="max-width: 200px; min-width: 200px" :sortable="true"
                                frozen></Column>

                        <Column field="name" header="Name" style="max-width: 500px; min-width: 500px" :sortable="true"></Column>

                        <Column field="exchange" header="Exchange" style="max-width: 200px; min-width: 200px" :sortable="true"></Column>

                        <Column field="type" header="Type" style="max-width: 200px; min-width: 200px" :sortable="true"></Column>

                    </DataTable>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 2" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callReset"></Button>

                    <DataTable
                        :value="stockHistory"
                        :paginator="true"
                        class="p-datatable-gridlines"
                        :rows="100"
                        dataKey="id"
                        :rowsPerPageOptions="[10,20,50,100]"
                        :rowHover="true"
                        :striped-rows="true"
                        :reorderableColumns="true"
                        :sortMode="'multiple'"
                        filterDisplay="menu"
                        :loading="loading"
                        responsiveLayout="scroll"
                        :globalFilterFields="['exchange', 'code']">

                        <template #empty>
                            No stock history found.
                        </template>

                        <template #loading>
                            Loading stock history. Please wait.
                        </template>

                        <Column field="year" header="Year"
                                :sortable="true"/>

                        <Column field="dividendPerShare" header="Dividend Per Share" style="min-width:12rem">
                            <template #body="{data}">
                                <span class="p-column-title">Dividend Per Share</span>
                                {{ formatAmount(data.dividendPerShare) }}
                            </template>
                        </Column>

                        <Column field="highSharePrice" header="High Share Price" style="min-width:12rem">
                            <template #body="{data}">
                                <span class="p-column-title">High Share Price</span>
                                {{ formatAmount(data.highSharePrice) }}
                            </template>
                        </Column>

                        <Column field="lowSharePrice" header="Low Share Price" style="min-width:12rem">
                            <template #body="{data}">
                                <span class="p-column-title">Low Share Price</span>
                                {{ formatAmount(data.lowSharePrice) }}
                            </template>
                        </Column>

                        <Column field="eps" header="EPS" style="min-width:12rem">
                            <template #body="{data}">
                                <span class="p-column-title">EPS</span>
                                {{ formatAmount(data.eps) }}
                            </template>
                        </Column>

                        <Column field="averageSharePrice" header="Average Share Price" style="min-width:12rem">
                            <template #body="{data}">
                                <span class="p-column-title">Average Share Price</span>
                                {{ formatAmount(data.averageSharePrice) }}
                            </template>
                        </Column>

                        <Column field="averageDividendYield" header="Average Dividend Yield" style="min-width:12rem">
                            <template #body="{data}">
                                <span class="p-column-title">Average Dividend Yield</span>
                                {{ formatAmount(data.averageDividendYield) }}
                            </template>
                        </Column>

                        <Column field="highDividendYield" header="High Dividend Yield" style="min-width:12rem">
                            <template #body="{data}">
                                <span class="p-column-title">High Dividend Yield</span>
                                {{ formatAmount(data.highDividendYield) }}
                            </template>
                        </Column>

                        <Column field="lowDividendYield" header="Low Dividend Yield" style="min-width:12rem">
                            <template #body="{data}">
                                <span class="p-column-title">Low Dividend Yield</span>
                                {{ formatAmount(data.lowDividendYield) }}
                            </template>
                        </Column>

                        <Column field="averagePeRatio" header="Average P/E Ratio" style="min-width:12rem">
                            <template #body="{data}">
                                <span class="p-column-title">Average P/E Ratio</span>
                                {{ formatAmount(data.averagePeRatio) }}
                            </template>
                        </Column>

                        <Column field="highPeRatio" header="High P/E Ratio" style="min-width:12rem">
                            <template #body="{data}">
                                <span class="p-column-title">High P/E Ratio</span>
                                {{ formatAmount(data.highPeRatio) }}
                            </template>
                        </Column>

                        <Column field="lowPeRatio" header="Low P/E Ratio" style="min-width:12rem">
                            <template #body="{data}">
                                <span class="p-column-title">Low P/E Ratio</span>
                                {{ formatAmount(data.lowPeRatio) }}
                            </template>
                        </Column>

                        <Column field="dividendGrowth" header="Dividend Growth" style="min-width:12rem">
                            <template #body="{data}">
                                <span class="p-column-title">Dividend Growth</span>
                                {{ formatAmount(data.dividendGrowth) }}
                            </template>
                        </Column>

                        <Column field="epsGrowth" header="EPS Growth" style="min-width:12rem">
                            <template #body="{data}">
                                <span class="p-column-title">EPS Growth</span>
                                {{ formatAmount(data.epsGrowth) }}
                            </template>
                        </Column>

                    </DataTable>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 3" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callReset"></Button>

                    <div class="field">
                        <label for="codeId129">Code</label>
                        <InputText id="codeId129" type="text" :disabled="true"
                                   v-model.trim="stockData.codeId129"/>
                    </div>

                    <div class="field">
                        <label for="hspWeek52Id001">001. 52wk High (API)</label>
                        <InputText id="hspWeek52Id001" type="text" :disabled="true"
                                   v-model.trim="stockData.hspWeek52Id001"/>
                    </div>

                    <div class="field">
                        <label for="lspWeek52Id002">002. 52wk Low (API)</label>
                        <InputText id="lspWeek52Id002" type="text" :disabled="true"
                                   v-model.trim="stockData.lspWeek52Id002"/>
                    </div>

                    <div class="field">
                        <label for="altmanZscoreId003">003. Altman Z-Score (API)</label>
                        <InputText id="altmanZscoreId003" type="text" :disabled="true"
                                   v-model.trim="stockData.altmanZscoreId003"/>
                    </div>

                    <div class="field">
                        <label for="afdId004">004. Annual Fwd Dividend (API)</label>
                        <InputText id="afdId004" type="text" :disabled="true"
                                   v-model.trim="stockData.afdId004"/>
                    </div>

                    <div class="field">
                        <label for="afdPreviousId005">005. R9 - Fwd Dividend vs Prev Year</label>
                        <InputText id="afdPreviousId005" type="text" :disabled="true"
                                   v-model.trim="stockData.afdPreviousId005"/>
                    </div>

                    <div class="field">
                        <label for="adgYear5Id006">006. R6 – Avg Div Growth 5yr</label>
                        <InputText id="adgYear5Id006" type="text" :disabled="true"
                                   v-model.trim="stockData.adgYear5Id006"/>
                    </div>

                    <div class="field">
                        <label for="adgYear10Id007">007. R6 – Avg Div Growth 10yr</label>
                        <InputText id="adgYear10Id007" type="text" :disabled="true"
                                   v-model.trim="stockData.adgYear10Id007"/>
                    </div>

                    <div class="field">
                        <label for="adgYear15Id008">008. R6 – Avg Div Growth 15yr</label>
                        <InputText id="adgYear15Id008" type="text" :disabled="true"
                                   v-model.trim="stockData.adgYear15Id008"/>
                    </div>

                    <div class="field">
                        <label for="adgYear20Id009">009. R6 – Avg Div Growth 20yr</label>
                        <InputText id="adgYear20Id009" type="text" :disabled="true"
                                   v-model.trim="stockData.adgYear20Id009"/>
                    </div>

                    <div class="field">
                        <label for="adyYear5Id010">010. Avg Div Yld 5yr</label>
                        <InputText id="adyYear5Id010" type="text" :disabled="true"
                                   v-model.trim="stockData.adyYear5Id010"/>
                    </div>

                    <div class="field">
                        <label for="adyYear10Id011">011. Avg Div Yld 10yr</label>
                        <InputText id="adyYear10Id011" type="text" :disabled="true"
                                   v-model.trim="stockData.adyYear10Id011"/>
                    </div>

                    <div class="field">
                        <label for="adyYear15Id012">012. Avg Div Yld 15yr</label>
                        <InputText id="adyYear15Id012" type="text" :disabled="true"
                                   v-model.trim="stockData.adyYear15Id012"/>
                    </div>

                    <div class="field">
                        <label for="adyYear20Id013">013. Avg Div Yld 20yr</label>
                        <InputText id="adyYear20Id013" type="text" :disabled="true"
                                   v-model.trim="stockData.adyYear20Id013"/>
                    </div>

                    <div class="field">
                        <label for="averageEpsYear3Id014">014. Avg 3yr EPS</label>
                        <InputText id="averageEpsYear3Id014" type="text" :disabled="true"
                                   v-model.trim="stockData.averageEpsYear3Id014"/>
                    </div>

                    <div class="field">
                        <label for="averageEpsGrowthYear5Id015">015. R5a – Avg EPS Growth 5yr</label>
                        <InputText id="averageEpsGrowthYear5Id015" type="text" :disabled="true"
                                   v-model.trim="stockData.averageEpsGrowthYear5Id015"/>
                    </div>

                    <div class="field">
                        <label for="averageEpsGrowthYear10Id016">016. R5a – Avg EPS Growth 10yr</label>
                        <InputText id="averageEpsGrowthYear10Id016" type="text" :disabled="true"
                                   v-model.trim="stockData.averageEpsGrowthYear10Id016"/>
                    </div>

                    <div class="field">
                        <label for="averageEpsGrowthYear15Id017">017. R5a – Avg EPS Growth 15yr</label>
                        <InputText id="averageEpsGrowthYear15Id017" type="text" :disabled="true"
                                   v-model.trim="stockData.averageEpsGrowthYear15Id017"/>
                    </div>

                    <div class="field">
                        <label for="averageEpsGrowthYear20Id018">018. R5a – Avg EPS Growth 20yr</label>
                        <InputText id="averageEpsGrowthYear20Id018" type="text" :disabled="true"
                                   v-model.trim="stockData.averageEpsGrowthYear20Id018"/>
                    </div>

                    <div class="field">
                        <label for="averageHdyYear5Id019">019. Avg High Div Yld 5yr</label>
                        <InputText id="averageHdyYear5Id019" type="text" :disabled="true"
                                   v-model.trim="stockData.averageHdyYear5Id019"/>
                    </div>

                    <div class="field">
                        <label for="averageHdyYear10Id020">020. Avg High Div Yld 10yr</label>
                        <InputText id="averageHdyYear10Id020" type="text" :disabled="true"
                                   v-model.trim="stockData.averageHdyYear10Id020"/>
                    </div>

                    <div class="field">
                        <label for="averageHdyYear15Id021">021. Avg High Div Yld 15yr</label>
                        <InputText id="averageHdyYear15Id021" type="text" :disabled="true"
                                   v-model.trim="stockData.averageHdyYear15Id021"/>
                    </div>

                    <div class="field">
                        <label for="averageHdyYear20Id022">022. Avg High Div Yld 20yr</label>
                        <InputText id="averageHdyYear20Id022" type="text" :disabled="true"
                                   v-model.trim="stockData.averageHdyYear20Id022"/>
                    </div>

                    <div class="field">
                        <label for="averageHighPeRatioYear5Id023">023. Avg High P/E 5yr</label>
                        <InputText id="averageHighPeRatioYear5Id023" type="text" :disabled="true"
                                   v-model.trim="stockData.averageHighPeRatioYear5Id023"/>
                    </div>

                    <div class="field">
                        <label for="averageHighPeRatioYear10Id024">024. Avg High P/E 10yr</label>
                        <InputText id="averageHighPeRatioYear10Id024" type="text" :disabled="true"
                                   v-model.trim="stockData.averageHighPeRatioYear10Id024"/>
                    </div>

                    <div class="field">
                        <label for="averageHighPeRatioYear15Id025">025. Avg High P/E 15yr</label>
                        <InputText id="averageHighPeRatioYear15Id025" type="text" :disabled="true"
                                   v-model.trim="stockData.averageHighPeRatioYear15Id025"/>
                    </div>

                    <div class="field">
                        <label for="averageHighPeRatioYear20Id026">026. Avg High P/E 20yr</label>
                        <InputText id="averageHighPeRatioYear20Id026" type="text" :disabled="true"
                                   v-model.trim="stockData.averageHighPeRatioYear20Id026"/>
                    </div>

                    <div class="field">
                        <label for="averageLdyYear5Id027">027. Avg Low Div Yld 5yr</label>
                        <InputText id="averageLdyYear5Id027" type="text" :disabled="true"
                                   v-model.trim="stockData.averageLdyYear5Id027"/>
                    </div>

                    <div class="field">
                        <label for="averageLdyYear10Id028">028. Avg Low Div Yld 10yr</label>
                        <InputText id="averageLdyYear10Id028" type="text" :disabled="true"
                                   v-model.trim="stockData.averageLdyYear10Id028"/>
                    </div>

                    <div class="field">
                        <label for="averageLdyYear15Id029">029. Avg Low Div Yld 15yr</label>
                        <InputText id="averageLdyYear15Id029" type="text" :disabled="true"
                                   v-model.trim="stockData.averageLdyYear15Id029"/>
                    </div>

                    <div class="field">
                        <label for="averageLdyYear20Id030">030. Avg Low Div Yld 20yr</label>
                        <InputText id="averageLdyYear20Id030" type="text" :disabled="true"
                                   v-model.trim="stockData.averageLdyYear20Id030"/>
                    </div>

                    <div class="field">
                        <label for="averageLowPeRatioYear5Id031">031. Avg Low P/E 5yr</label>
                        <InputText id="averageLowPeRatioYear5Id031" type="text" :disabled="true"
                                   v-model.trim="stockData.averageLowPeRatioYear5Id031"/>
                    </div>

                    <div class="field">
                        <label for="averageLowPeRatioYear10Id032">032. Avg Low P/E 10yr</label>
                        <InputText id="averageLowPeRatioYear10Id032" type="text" :disabled="true"
                                   v-model.trim="stockData.averageLowPeRatioYear10Id032"/>
                    </div>

                    <div class="field">
                        <label for="averageLowPeRatioYear15Id033">033. Avg Low P/E 15yr</label>
                        <InputText id="averageLowPeRatioYear15Id033" type="text" :disabled="true"
                                   v-model.trim="stockData.averageLowPeRatioYear15Id033"/>
                    </div>

                    <div class="field">
                        <label for="averageLowPeRatioYear20Id034">034. Avg Low P/E 20yr</label>
                        <InputText id="averageLowPeRatioYear20Id034" type="text" :disabled="true"
                                   v-model.trim="stockData.averageLowPeRatioYear20Id034"/>
                    </div>

                    <div class="field">
                        <label for="averagePeRatioYear5Id035">035. Avg P/E 5yr</label>
                        <InputText id="averagePeRatioYear5Id035" type="text" :disabled="true"
                                   v-model.trim="stockData.averagePeRatioYear5Id035"/>
                    </div>

                    <div class="field">
                        <label for="averagePeRatioYear10Id036">036. Avg P/E 10yr</label>
                        <InputText id="averagePeRatioYear10Id036" type="text" :disabled="true"
                                   v-model.trim="stockData.averagePeRatioYear10Id036"/>
                    </div>

                    <div class="field">
                        <label for="averagePeRatioYear15Id037">037. Avg P/E 15yr</label>
                        <InputText id="averagePeRatioYear15Id037" type="text" :disabled="true"
                                   v-model.trim="stockData.averagePeRatioYear15Id037"/>
                    </div>

                    <div class="field">
                        <label for="averagePeRatioYear20Id038">038. Avg P/E 20yr</label>
                        <InputText id="averagePeRatioYear20Id038" type="text" :disabled="true"
                                   v-model.trim="stockData.averagePeRatioYear20Id038"/>
                    </div>

                    <div class="field">
                        <label for="bookValuePerShareId039">039. Bk Value/Share (API)</label>
                        <InputText id="bookValuePerShareId039" type="text" :disabled="true"
                                   v-model.trim="stockData.bookValuePerShareId039"/>
                    </div>

                    <div class="field">
                        <label for="cashFlowPerShareId040">040. Cashflow/Share (API)</label>
                        <InputText id="cashFlowPerShareId040" type="text" :disabled="true"
                                   v-model.trim="stockData.cashFlowPerShareId040"/>
                    </div>

                    <div class="field">
                        <label for="companyAddressCityId041">041. City (API)</label>
                        <InputText id="companyAddressCityId041" type="text" :disabled="true"
                                   v-model.trim="stockData.companyAddressCityId041"/>
                    </div>

                    <div class="field">
                        <label for="companyAddressCountryId042">042. Country (API)</label>
                        <InputText id="companyAddressCountryId042" type="text" :disabled="true"
                                   v-model.trim="stockData.companyAddressCountryId042"/>
                    </div>

                    <div class="field">
                        <label for="companyAddressStateId043">043. State/Prov (API)</label>
                        <InputText id="companyAddressStateId043" type="text" :disabled="true"
                                   v-model.trim="stockData.companyAddressStateId043"/>
                    </div>

                    <div class="field">
                        <label for="companyAddressId044">044. Address (API)</label>
                        <InputText id="companyAddressId044" type="text" :disabled="true"
                                   v-model.trim="stockData.companyAddressId044"/>
                    </div>

                    <div class="field">
                        <label for="companyDescriptionId045">045. Description (API)</label>
                        <InputText id="companyDescriptionId045" type="text" :disabled="true"
                                   v-model.trim="stockData.companyDescriptionId045"/>
                    </div>

                    <div class="field">
                        <label for="companyNameId046">046. Name (API)</label>
                        <InputText id="companyNameId046" type="text" :disabled="true"
                                   v-model.trim="stockData.companyNameId046"/>
                    </div>

                    <div class="field">
                        <label for="yearsDividendIncreasesId047">047. Consecutive Yrs Div Increases</label>
                        <InputText id="yearsDividendIncreasesId047" type="text" :disabled="true"
                                   v-model.trim="stockData.yearsDividendIncreasesId047"/>
                    </div>

                    <div class="field">
                        <label for="yearsEpsIncreasesId048">048. Consecutive Yrs EPS Increases</label>
                        <InputText id="yearsEpsIncreasesId048" type="text" :disabled="true"
                                   v-model.trim="stockData.yearsEpsIncreasesId048"/>
                    </div>

                    <div class="field">
                        <label for="currentAssetsId049">049. Current Assets</label>
                        <InputText id="currentAssetsId049" type="text" :disabled="true"
                                   v-model.trim="stockData.currentAssetsId049"/>
                    </div>

                    <div class="field">
                        <label for="currentDividendYieldId050">050. Current Div Yld</label>
                        <InputText id="currentDividendYieldId050" type="text" :disabled="true"
                                   v-model.trim="stockData.currentDividendYieldId050"/>
                    </div>

                    <div class="field">
                        <label for="currentLiabilitiesId051">051. Current Debt (API)</label>
                        <InputText id="currentLiabilitiesId051" type="text" :disabled="true"
                                   v-model.trim="stockData.currentLiabilitiesId051"/>
                    </div>

                    <div class="field">
                        <label for="currentRatioId052">052. Current Ratio (API)</label>
                        <InputText id="currentRatioId052" type="text" :disabled="true"
                                   v-model.trim="stockData.currentRatioId052"/>
                    </div>

                    <div class="field">
                        <label for="diffDyCurrentVsAverageYear5Id053">053. Diff Between Current Div Yld & Avg Div Yld
                            5yrs</label>
                        <InputText id="diffDyCurrentVsAverageYear5Id053" type="text" :disabled="true"
                                   v-model.trim="stockData.diffDyCurrentVsAverageYear5Id053"/>
                    </div>

                    <div class="field">
                        <label for="diffDyCurrentVsAverageYear10Id054">054. Diff Between Current Div Yld & Avg Div Yld
                            10yrs</label>
                        <InputText id="diffDyCurrentVsAverageYear10Id054" type="text" :disabled="true"
                                   v-model.trim="stockData.diffDyCurrentVsAverageYear10Id054"/>
                    </div>

                    <div class="field">
                        <label for="diffDyCurrentVsAverageYear15Id055">055. Diff Between Current Div Yld & Avg Div Yld
                            15yrs</label>
                        <InputText id="diffDyCurrentVsAverageYear15Id055" type="text" :disabled="true"
                                   v-model.trim="stockData.diffDyCurrentVsAverageYear15Id055"/>
                    </div>

                    <div class="field">
                        <label for="diffDyCurrentVsAverageYear20Id056">056. Diff Between Current Div Yld & Avg Div Yld
                            20yrs</label>
                        <InputText id="diffDyCurrentVsAverageYear20Id056" type="text" :disabled="true"
                                   v-model.trim="stockData.diffDyCurrentVsAverageYear20Id056"/>
                    </div>

                    <div class="field">
                        <label for="diffPeCurrentVsAverageYear5Id057">057. Diff Between Current P/E & Avg P/E
                            5yrs</label>
                        <InputText id="diffPeCurrentVsAverageYear5Id057" type="text" :disabled="true"
                                   v-model.trim="stockData.diffPeCurrentVsAverageYear5Id057"/>
                    </div>

                    <div class="field">
                        <label for="diffPeCurrentVsAverageYear10Id058">058. Diff Between Current P/E & Avg P/E
                            10yrs</label>
                        <InputText id="diffPeCurrentVsAverageYear10Id058" type="text" :disabled="true"
                                   v-model.trim="stockData.diffPeCurrentVsAverageYear10Id058"/>
                    </div>

                    <div class="field">
                        <label for="diffPeCurrentVsAverageYear15Id059">059. Diff Between Current P/E & Avg P/E
                            15yrs</label>
                        <InputText id="diffPeCurrentVsAverageYear15Id059" type="text" :disabled="true"
                                   v-model.trim="stockData.diffPeCurrentVsAverageYear15Id059"/>
                    </div>

                    <div class="field">
                        <label for="diffPeCurrentVsAverageYear20Id060">060. Diff Between Current P/E & Avg P/E
                            20yrs</label>
                        <InputText id="diffPeCurrentVsAverageYear20Id060" type="text" :disabled="true"
                                   v-model.trim="stockData.diffPeCurrentVsAverageYear20Id060"/>
                    </div>

                    <div class="field">
                        <label for="dcfId061">061. DCF (API)</label>
                        <InputText id="dcfId061" type="text" :disabled="true"
                                   v-model.trim="stockData.dcfId061"/>
                    </div>

                    <div class="field">
                        <label for="dividendCurrencyId062">062. Div Currency (API)</label>
                        <InputText id="dividendCurrencyId062" type="text" :disabled="true"
                                   v-model.trim="stockData.dividendCurrencyId062"/>
                    </div>

                    <div class="field">
                        <label for="dividendFrequencyId063">063. Div Frequency (API)</label>
                        <InputText id="dividendFrequencyId063" type="text" :disabled="true"
                                   v-model.trim="stockData.dividendFrequencyId063"/>
                    </div>

                    <div class="field">
                        <label for="dgPlusDyYear5Id064">064. Div Gr (5yr) + Curr Div Yld</label>
                        <InputText id="dgPlusDyYear5Id064" type="text" :disabled="true"
                                   v-model.trim="stockData.dgPlusDyYear5Id064"/>
                    </div>

                    <div class="field">
                        <label for="dgPlusDyYear10Id065">065. Div Gr (10yr) + Curr Div Yld</label>
                        <InputText id="dgPlusDyYear10Id065" type="text" :disabled="true"
                                   v-model.trim="stockData.dgPlusDyYear10Id065"/>
                    </div>

                    <div class="field">
                        <label for="dgPlusDyYear15Id066">066. Div Gr (15yr) + Curr Div Yld</label>
                        <InputText id="dgPlusDyYear15Id066" type="text" :disabled="true"
                                   v-model.trim="stockData.dgPlusDyYear15Id066"/>
                    </div>

                    <div class="field">
                        <label for="dgPlusDyYear20Id067">067. Div Gr (20yr) + Curr Div Yld</label>
                        <InputText id="dgPlusDyYear20Id067" type="text" :disabled="true"
                                   v-model.trim="stockData.dgPlusDyYear20Id067"/>
                    </div>

                    <div class="field">
                        <label for="dividendPaymentDateId068">068. Div Payment Date (API)</label>
                        <InputText id="dividendPaymentDateId068" type="text" :disabled="true"
                                   v-model.trim="stockData.dividendPaymentDateId068"/>
                    </div>

                    <div class="field">
                        <label for="dividendRecordDateId069">069. Div Record Date (API)</label>
                        <InputText id="dividendRecordDateId069" type="text" :disabled="true"
                                   v-model.trim="stockData.dividendRecordDateId069"/>
                    </div>

                    <div class="field">
                        <label for="dividendPaidId070">070. Divs Paid Since</label>
                        <InputText id="dividendPaidId070" type="text" :disabled="true"
                                   v-model.trim="stockData.dividendPaidId070"/>
                    </div>

                    <div class="field">
                        <label for="epsTtmId071">071. EPS (TTM) (API)</label>
                        <InputText id="epsTtmId071" type="text" :disabled="true"
                                   v-model.trim="stockData.epsTtmId071"/>
                    </div>

                    <div class="field">
                        <label for="esgScoreId072">072. ESG Score (API)</label>
                        <InputText id="esgScoreId072" type="text" :disabled="true"
                                   v-model.trim="stockData.esgScoreId072"/>
                    </div>

                    <div class="field">
                        <label for="exchangeId073">073. Exchange (API)</label>
                        <InputText id="exchangeId073" type="text" :disabled="true"
                                   v-model.trim="stockData.exchangeId073"/>
                    </div>

                    <div class="field">
                        <label for="exDividendDateId074">074. Ex-Div Date (API)</label>
                        <InputText id="exDividendDateId074" type="text" :disabled="true"
                                   v-model.trim="stockData.exDividendDateId074"/>
                    </div>

                    <div class="field">
                        <label for="fiscalYearendDateId075">075. Fiscal Yr End (API)</label>
                        <InputText id="fiscalYearendDateId075" type="text" :disabled="true"
                                   v-model.trim="stockData.fiscalYearendDateId075"/>
                    </div>

                    <div class="field">
                        <label for="grahamPriceId076">076. Graham Price</label>
                        <InputText id="grahamPriceId076" type="text" :disabled="true"
                                   v-model.trim="stockData.grahamPriceId076"/>
                    </div>

                    <div class="field">
                        <label for="hspYear5Id077">077. High Price Using 5yr Data</label>
                        <InputText id="hspYear5Id077" type="text" :disabled="true"
                                   v-model.trim="stockData.hspYear5Id077"/>
                    </div>

                    <div class="field">
                        <label for="hspYear10Id078">078. High Price Using 10yr Data</label>
                        <InputText id="hspYear10Id078" type="text" :disabled="true"
                                   v-model.trim="stockData.hspYear10Id078"/>
                    </div>

                    <div class="field">
                        <label for="hspYear15Id079">079. High Price Using 15yr Data</label>
                        <InputText id="hspYear15Id079" type="text" :disabled="true"
                                   v-model.trim="stockData.hspYear15Id079"/>
                    </div>

                    <div class="field">
                        <label for="hspYear20Id080">080. High Price Using 20yr Data</label>
                        <InputText id="hspYear20Id080" type="text" :disabled="true"
                                   v-model.trim="stockData.hspYear20Id080"/>
                    </div>

                    <div class="field">
                        <label for="industryId081">081. Industry (API)</label>
                        <InputText id="industryId081" type="text" :disabled="true"
                                   v-model.trim="stockData.industryId081"/>
                    </div>

                    <div class="field">
                        <label for="longtermDebtId082">082. LT Debt (API)</label>
                        <InputText id="longtermDebtId082" type="text" :disabled="true"
                                   v-model.trim="stockData.longtermDebtId082"/>
                    </div>

                    <div class="field">
                        <label for="longtermDebtVsTotalCapitalId083">083. LT Debt/Total Capital (API)</label>
                        <InputText id="longtermDebtVsTotalCapitalId083" type="text" :disabled="true"
                                   v-model.trim="stockData.longtermDebtVsTotalCapitalId083"/>
                    </div>

                    <div class="field">
                        <label for="longtermDebtEquityRatioId084">084. R8 - LT Debt/Equity</label>
                        <InputText id="longtermDebtEquityRatioId084" type="text" :disabled="true"
                                   v-model.trim="stockData.longtermDebtEquityRatioId084"/>
                    </div>

                    <div class="field">
                        <label for="lspYear5Id085">085. Low Price Using 5yr Data</label>
                        <InputText id="lspYear5Id085" type="text" :disabled="true"
                                   v-model.trim="stockData.lspYear5Id085"/>
                    </div>

                    <div class="field">
                        <label for="lspYear10Id086">086. Low Price Using 10yr Data</label>
                        <InputText id="lspYear10Id086" type="text" :disabled="true"
                                   v-model.trim="stockData.lspYear10Id086"/>
                    </div>

                    <div class="field">
                        <label for="lspYear15Id087">087. Low Price Using 15yr Data</label>
                        <InputText id="lspYear15Id087" type="text" :disabled="true"
                                   v-model.trim="stockData.lspYear15Id087"/>
                    </div>

                    <div class="field">
                        <label for="lspYear20Id088">088. Low Price Using 20yr Data</label>
                        <InputText id="lspYear20Id088" type="text" :disabled="true"
                                   v-model.trim="stockData.lspYear20Id088"/>
                    </div>

                    <div class="field">
                        <label for="marketId089">089. Market/Country (API)</label>
                        <InputText id="marketId089" type="text" :disabled="true"
                                   v-model.trim="stockData.marketId089"/>
                    </div>

                    <div class="field">
                        <label for="marketCapitalisationId090">090. Market Cap (API)</label>
                        <InputText id="marketCapitalisationId090" type="text" :disabled="true"
                                   v-model.trim="stockData.marketCapitalisationId090"/>
                    </div>

                    <div class="field">
                        <label for="netIncomeId091">091. Net Income (API)</label>
                        <InputText id="netIncomeId091" type="text" :disabled="true"
                                   v-model.trim="stockData.netIncomeId091"/>
                    </div>

                    <div class="field">
                        <label for="netIncomePerShareId092">092. Net Income/Share TTM (API)</label>
                        <InputText id="netIncomePerShareId092" type="text" :disabled="true"
                                   v-model.trim="stockData.netIncomePerShareId092"/>
                    </div>

                    <div class="field">
                        <label for="employeesId093">093. Employees (API)</label>
                        <InputText id="employeesId093" type="text" :disabled="true"
                                   v-model.trim="stockData.employeesId093"/>
                    </div>

                    <div class="field">
                        <label for="epsIncreasesYear5Id094">094. R5b – EPS Increases in 5yrs</label>
                        <InputText id="epsIncreasesYear5Id094" type="text" :disabled="true"
                                   v-model.trim="stockData.epsIncreasesYear5Id094"/>
                    </div>

                    <div class="field">
                        <label for="epsIncreasesYear10Id095">095. R5b – EPS Increases in 10yrs</label>
                        <InputText id="epsIncreasesYear10Id095" type="text" :disabled="true"
                                   v-model.trim="stockData.epsIncreasesYear10Id095"/>
                    </div>

                    <div class="field">
                        <label for="epsIncreasesYear15Id096">096. R5b – EPS Increases in 15yrs</label>
                        <InputText id="epsIncreasesYear15Id096" type="text" :disabled="true"
                                   v-model.trim="stockData.epsIncreasesYear15Id096"/>
                    </div>

                    <div class="field">
                        <label for="epsIncreasesYear20Id097">097. R5b – EPS Increases in 20yrs</label>
                        <InputText id="epsIncreasesYear20Id097" type="text" :disabled="true"
                                   v-model.trim="stockData.epsIncreasesYear20Id097"/>
                    </div>

                    <div class="field">
                        <label for="outstandingSharesCurrentYearId098">098. Shares Outstanding (API)</label>
                        <InputText id="outstandingSharesCurrentYearId098" type="text" :disabled="true"
                                   v-model.trim="stockData.outstandingSharesCurrentYearId098"/>
                    </div>

                    <div class="field">
                        <label for="outstandingSharesPreviousYearId099">099. Shares Outstanding (previous Yr)
                            (API)</label>
                        <InputText id="outstandingSharesPreviousYearId099" type="text" :disabled="true"
                                   v-model.trim="stockData.outstandingSharesPreviousYearId099"/>
                    </div>

                    <div class="field">
                        <label for="operatingCashflowId100">100. Operating Cashflow (API)</label>
                        <InputText id="operatingCashflowId100" type="text" :disabled="true"
                                   v-model.trim="stockData.operatingCashflowId100"/>
                    </div>

                    <div class="field">
                        <label for="operatingCashflowRatioId101">101. Operating Cashflow Ratio</label>
                        <InputText id="operatingCashflowRatioId101" type="text" :disabled="true"
                                   v-model.trim="stockData.operatingCashflowRatioId101"/>
                    </div>

                    <div class="field">
                        <label for="pbRatioId102">102. R11c – P/B Ratio</label>
                        <InputText id="pbRatioId102" type="text" :disabled="true"
                                   v-model.trim="stockData.pbRatioId102"/>
                    </div>

                    <div class="field">
                        <label for="pcfRatioId103">103. P/CF Ratio (API)</label>
                        <InputText id="pcfRatioId103" type="text" :disabled="true"
                                   v-model.trim="stockData.pcfRatioId103"/>
                    </div>

                    <div class="field">
                        <label for="peRatioId104">104. R11a – P/E Ratio TTM</label>
                        <InputText id="peRatioId104" type="text" :disabled="true"
                                   v-model.trim="stockData.peRatioId104"/>
                    </div>

                    <div class="field">
                        <label for="pfcfRatioId105">105. P/FCF Ratio (API)</label>
                        <InputText id="pfcfRatioId105" type="text" :disabled="true"
                                   v-model.trim="stockData.pfcfRatioId105"/>
                    </div>

                    <div class="field">
                        <label for="psRatioId106">106. P/S Ratio (API)</label>
                        <InputText id="psRatioId106" type="text" :disabled="true"
                                   v-model.trim="stockData.psRatioId106"/>
                    </div>

                    <div class="field">
                        <label for="payoutRatioId107">107. R7 – Payout Ratio</label>
                        <InputText id="payoutRatioId107" type="text" :disabled="true"
                                   v-model.trim="stockData.payoutRatioId107"/>
                    </div>

                    <div class="field">
                        <label for="pegRatioYear5Id108">108. PEG Ratio Using Avg EPS Growth 5yr</label>
                        <InputText id="pegRatioYear5Id108" type="text" :disabled="true"
                                   v-model.trim="stockData.pegRatioYear5Id108"/>
                    </div>

                    <div class="field">
                        <label for="pegRatioYear10Id109">109. PEG Ratio Using Avg EPS Growth 10yr</label>
                        <InputText id="pegRatioYear10Id109" type="text" :disabled="true"
                                   v-model.trim="stockData.pegRatioYear10Id109"/>
                    </div>

                    <div class="field">
                        <label for="pegRatioYear15Id110">110. PEG Ratio Using Avg EPS Growth 15yr</label>
                        <InputText id="pegRatioYear15Id110" type="text" :disabled="true"
                                   v-model.trim="stockData.pegRatioYear15Id110"/>
                    </div>

                    <div class="field">
                        <label for="pegRatioYear20Id111">111. PEG Ratio Using Avg EPS Growth 20yr</label>
                        <InputText id="pegRatioYear20Id111" type="text" :disabled="true"
                                   v-model.trim="stockData.pegRatioYear20Id111"/>
                    </div>

                    <div class="field">
                        <label for="diffGrahamPriceSharePriceId112">112. % diff Graham Price vs Share Price</label>
                        <InputText id="diffGrahamPriceSharePriceId112" type="text" :disabled="true"
                                   v-model.trim="stockData.diffGrahamPriceSharePriceId112"/>
                    </div>

                    <div class="field">
                        <label for="sharesOwnedInstitutionsId113">113. % Owned by Institutions (API)</label>
                        <InputText id="sharesOwnedInstitutionsId113" type="text" :disabled="true"
                                   v-model.trim="stockData.sharesOwnedInstitutionsId113"/>
                    </div>

                    <div class="field">
                        <label for="piotroskiFscoreId114">114. Piotroski F-Score (API)</label>
                        <InputText id="piotroskiFscoreId114" type="text" :disabled="true"
                                   v-model.trim="stockData.piotroskiFscoreId114"/>
                    </div>

                    <div class="field">
                        <label for="profitMarginId115">115. Total Operating Profit Margin (API)</label>
                        <InputText id="profitMarginId115" type="text" :disabled="true"
                                   v-model.trim="stockData.profitMarginId115"/>
                    </div>

                    <div class="field">
                        <label for="quickRatioId116">116. Quick Ratio (API)</label>
                        <InputText id="quickRatioId116" type="text" :disabled="true"
                                   v-model.trim="stockData.quickRatioId116"/>
                    </div>

                    <div class="field">
                        <label for="recentDividendPaymentId117">117. Recent Div Payment (API)</label>
                        <InputText id="recentDividendPaymentId117" type="text" :disabled="true"
                                   v-model.trim="stockData.recentDividendPaymentId117"/>
                    </div>

                    <div class="field">
                        <label for="roaTtmId118">118. ROA TTM (API)</label>
                        <InputText id="roaTtmId118" type="text" :disabled="true"
                                   v-model.trim="stockData.roaTtmId118"/>
                    </div>

                    <div class="field">
                        <label for="rocTtmId119">119. ROC TTM (API)</label>
                        <InputText id="rocTtmId119" type="text" :disabled="true"
                                   v-model.trim="stockData.rocTtmId119"/>
                    </div>

                    <div class="field">
                        <label for="roeTtmId120">120. ROE TTM (API)</label>
                        <InputText id="roeTtmId120" type="text" :disabled="true"
                                   v-model.trim="stockData.roeTtmId120"/>
                    </div>

                    <div class="field">
                        <label for="sectorId121">121. Sector (API)</label>
                        <InputText id="sectorId121" type="text" :disabled="true"
                                   v-model.trim="stockData.sectorId121"/>
                    </div>

                    <div class="field">
                        <label for="shareBuybackId122">122. R10 – Share Buyback?</label>
                        <InputText id="shareBuybackId122" type="text" :disabled="true"
                                   v-model.trim="stockData.shareBuybackId122"/>
                    </div>

                    <div class="field">
                        <label for="sharePriceId123">123. Share Price (API)</label>
                        <InputText id="sharePriceId123" type="text" :disabled="true"
                                   v-model.trim="stockData.sharePriceId123"/>
                    </div>

                    <div class="field">
                        <label for="sharePriceDateId124">124. Share Date & Time (API)</label>
                        <InputText id="sharePriceDateId124" type="text" :disabled="true"
                                   v-model.trim="stockData.sharePriceDateId124"/>
                    </div>

                    <div class="field">
                        <label for="siCriteriaYear5Id125">125. SI Criteria out of 10 (5yr Data)</label>
                        <InputText id="siCriteriaYear5Id125" type="text" :disabled="true"
                                   v-model.trim="stockData.siCriteriaYear5Id125"/>
                    </div>

                    <div class="field">
                        <label for="siCriteriaYear10Id126">126. SI Criteria out of 10 (10yr Data)</label>
                        <InputText id="siCriteriaYear10Id126" type="text" :disabled="true"
                                   v-model.trim="stockData.siCriteriaYear10Id126"/>
                    </div>

                    <div class="field">
                        <label for="siCriteriaYear15Id127">127. SI Criteria out of 10 (15yr Data)</label>
                        <InputText id="siCriteriaYear15Id127" type="text" :disabled="true"
                                   v-model.trim="stockData.siCriteriaYear15Id127"/>
                    </div>

                    <div class="field">
                        <label for="siCriteriaYear20Id128">128. SI Criteria out of 10 (20yr Data)</label>
                        <InputText id="siCriteriaYear20Id128" type="text" :disabled="true"
                                   v-model.trim="stockData.siCriteriaYear20Id128"/>
                    </div>

                    <div class="field">
                        <label for="codeId129">129. Stock Symbol (API)</label>
                        <InputText id="codeId129" type="text" :disabled="true"
                                   v-model.trim="stockData.codeId129"/>
                    </div>

                    <div class="field">
                        <label for="totalDebtVsEquityRatioId130">130. Total Debt/Equity Ratio (API)</label>
                        <InputText id="totalDebtVsEquityRatioId130" type="text" :disabled="true"
                                   v-model.trim="stockData.totalDebtVsEquityRatioId130"/>
                    </div>

                    <div class="field">
                        <label for="totalStockholderEquityId131">131. Total Stockholder Equity (API)</label>
                        <InputText id="totalStockholderEquityId131" type="text" :disabled="true"
                                   v-model.trim="stockData.totalStockholderEquityId131"/>
                    </div>

                    <div class="field">
                        <label for="undervaluedVsOvervaluedStatusYear5Id132">132. R11b – Under/Over Valued Using 5yr
                            Data</label>
                        <InputText id="undervaluedVsOvervaluedStatusYear5Id132" type="text" :disabled="true"
                                   v-model.trim="stockData.undervaluedVsOvervaluedStatusYear5Id132"/>
                    </div>

                    <div class="field">
                        <label for="undervaluedVsOvervaluedStatusYear10Id133">133. R11b – Under/Over Valued Using 10yr
                            Data</label>
                        <InputText id="undervaluedVsOvervaluedStatusYear10Id133" type="text" :disabled="true"
                                   v-model.trim="stockData.undervaluedVsOvervaluedStatusYear10Id133"/>
                    </div>

                    <div class="field">
                        <label for="undervaluedVsOvervaluedStatusYear15Id134">134. R11b – Under/Over Valued Using 15yr
                            Data</label>
                        <InputText id="undervaluedVsOvervaluedStatusYear15Id134" type="text" :disabled="true"
                                   v-model.trim="stockData.undervaluedVsOvervaluedStatusYear15Id134"/>
                    </div>

                    <div class="field">
                        <label for="undervaluedVsOvervaluedStatusYear20Id135">135. R11b – Under/Over Valued Using 20yr
                            Data</label>
                        <InputText id="undervaluedVsOvervaluedStatusYear20Id135" type="text" :disabled="true"
                                   v-model.trim="stockData.undervaluedVsOvervaluedStatusYear20Id135"/>
                    </div>

                    <div class="field">
                        <label for="websiteId136">136. Website (API)</label>
                        <InputText id="websiteId136" type="text" :disabled="true"
                                   v-model.trim="stockData.websiteId136"/>
                    </div>

                    <div class="field">
                        <label for="websiteId136">137. Expense Ratio (API)</label>
                        <InputText id="websiteId136" type="text" :disabled="true"
                                   v-model.trim="stockData.expenseRatioId137"/>
                    </div>

                    <div class="field">
                        <label for="websiteId136">138. Yield (API)</label>
                        <InputText id="websiteId136" type="text" :disabled="true"
                                   v-model.trim="stockData.yieldId138"/>
                    </div>


                </div>
            </div>
        </div>

    </div>

    <IsoEvolveFooter/>

</template>

<script>
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import MenuSiModuleMain from "@/components/menu/simodule/MenuSiModuleMain.vue";
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import numeral from "numeral";
import {FilterMatchMode, FilterOperator} from "primevue/api";
import StockDataService from "@/service/StockDataService";
import StockHistoryService from "@/service/StockHistoryService";
import StockService from "@/service/StockService";

export default {
    components: {
        MenuSiModuleMain,
        IsoEvolveFooter
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    created() {
        this.initFilters();

        this.columnsDefault = [
            {field: 'codeId129', header: 'Stock Symbol', sortable: true},
            {field: 'typeId139', header: 'Type', sortable: true},
            {field: 'companyNameId046', header: 'Name', sortable: true},
            {field: 'sharePriceId123', header: 'Share Price', sortable: true}
        ];

        this.columnsFullList = [
            {field: 'codeId129', header: 'Stock Symbol', sortable: true},
            {field: 'typeId139', header: 'Type', sortable: true},
            {field: 'companyNameId046', header: 'Name', sortable: true},
            {field: 'sharePriceId123', header: 'Share Price', sortable: true},
            {field: 'averageEpsGrowthYear20Id018', header: 'R5a – Avg EPS Growth 20yr', sortable: true},
            {field: 'epsIncreasesYear20Id097', header: 'R5b – EPS Increases in 20yrs', sortable: true},
            {field: 'adgYear20Id009', header: 'R6 – Avg Div Growth 20yr', sortable: true},
            {field: 'payoutRatioId107', header: 'R7 – Payout Ratio', sortable: true},
            {field: 'longtermDebtEquityRatioId084', header: 'R8 - LT Debt/Equity', sortable: true},
            {field: 'afdPreviousId005', header: 'R9 - Fwd Dividend vs Prev Year', sortable: true},
            {field: 'shareBuybackId122', header: 'R10 – Share Buyback?', sortable: true},
            {field: 'peRatioId104', header: 'R11a – P/E Ratio TTM', sortable: true},
            {field: 'pbRatioId102', header: 'R11c – P/B Ratio', sortable: true},
            {field: 'yearsDividendIncreasesId047', header: 'Consecutive Yrs Div Increases', sortable: true},
            {field: 'currentDividendYieldId050', header: 'Current Div Yld', sortable: true}
        ];

        this.selectedColumns = this.columnsDefault;

    },
    async mounted() {
        try {
            // Attempt to get user data
            const userData = await UserService.getUser(this.userStore.user.id);
            this.profile = userData.data;
            console.log("[AppointmentsNew][mounted] Data = ", userData);
            console.log("[AppointmentsNew][mounted] this.profile = ", this.profile);
        } catch (e) {
            console.error("[AppointmentsNew][mounted] Error fetching user data = ", e);
            this.userStore.clearUser();
            // this.$router.push("login");
            this.$router.replace('/siLogin');
            return;
        }

        this.selectedExchange = "JSE";

        try {
            const [stockInfo] = await Promise.all([
                StockService.getStocksForExchange(this.selectedExchange, 'A')
            ]);

            this.stocks = stockInfo.data;
            this.originalStocks = stockInfo.data;
            console.log("[AppointmentsNew][mounted] stockInfo.data = ", stockInfo.data);

            this.loading = false;

        } catch (e) {
            console.error("[AppointmentsNew][mounted] Error fetching additional data = ", e);
        }

        console.log("[AppointmentsNew][mounted] this.stocks = ", this.stocks);
    },
    data() {

        return {
            profile: {},
            activeTab: 1,
            filters: null,
            loading: true,
            stock: {},
            // stocks: [],
            // stocksUsa: null,
            // stocksCanada: null,
            // stocksUk: null,
            // stocksSouthAfrica: null,
            stockHistory: [],
            stocks: [],
            originalStocks: [],
            stockData: {},
            confirmationResponse: 'N',
            selectedColumns: null,
            columnsDefault: null,
            columnsFullList: null,
            submitted: false,
            selectedStandardFilter: "topRanked",
            selectedExchange: "JSE",
            selectedFormat: "Compact",
            exchanges: [
                {name: 'NYSE', code: 'NYSE'},
                {name: 'NASDAQ', code: 'NASDAQ'},
                {name: 'TSX', code: 'TO'},
                {name: 'LSE', code: 'LSE'},
                {name: 'JSE', code: 'JSE'}
            ],
            formats: [
                {name: 'Compact View', code: 'Compact'},
                {name: 'Complete View', code: 'Complete'}
            ],
            standardFilters: [
                {name: 'Top Ranked', code: 'topRanked'},
                {name: 'Runners-Up', code: 'runnersUp'},
                {name: 'Dividend Stocks Undervalued', code: 'dividendStocksUndervalued'},
                {name: 'Dividend Stocks Overvalued', code: 'dividendStocksOvervalued'},
                {name: 'Dividend Stocks Deep Valued', code: 'dividendStocksDeepvalued'},
                {name: 'Non Dividend Stocks Undervalued', code: 'nondividendStocksUndervalued'},
                {name: 'Non Dividend Stocks Overvalued', code: 'nondividendStocksOvervalued'},
                {name: 'Non Dividend Stocks Deep valued', code: 'nondividendStocksDeepvalued'}
            ]
        }
    },
    computed: {
        formattedHspWeek52: {
            get() {
                return this.formatAmount(this.stockData.hspWeek52);
            },
            set(newValue) {
                // Define how to parse the formatted value back to the original format
                // This is just an example and might need more robust implementation
                this.stockData.hspWeek52 = parseFloat(newValue.replace(/[^0-9.-]+/g, ""));
            }
        },
        formattedBookValuePerShare: {
            get() {
                return this.formatAmount(this.stockData.bookValuePerShare);
            },
            set(newValue) {
                // Define how to parse the formatted value back to the original format
                // This is just an example and might need more robust implementation
                this.stockData.bookValuePerShare = parseFloat(newValue.replace(/[^0-9.-]+/g, ""));
            }
        }
    },
    methods: {
        initFilters() {
            this.filters = {
                'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'exchangeId073': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                },
                'codeId129': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                }
            }
        },
        clearFilter() {
            this.initFilters();
        },
        restoreToOriginal() {
            window.location.reload();
        },
        callReset() {
            this.activeTab = 1;
        },
        async onExchangeChange() {
            console.log("[Overview][onExchangeChange] this.selectedExchange = ", this.selectedExchange);

            try {
                const [stockInfo] = await Promise.all([
                    StockService.getStocksForExchange(this.selectedExchange, 'A')
                ]);

                this.stocks = stockInfo.data;
                this.originalStocks = stockInfo.data;
                console.log("[AppointmentsNew][mounted] stockInfo.data = ", stockInfo.data);

                this.loading = false;

            } catch (e) {
                console.error("[AppointmentsNew][mounted] Error fetching additional data = ", e);
            }
        },
        onToggleColumns(value) {
            this.selectedColumns = this.columnsFullList.filter(col => value.includes(col));
        },
        formatAmount(value) {
            if (value) {
                return numeral(String(value)).format('0,0.00');
            } else {
                return 0;
            }
        },
        async callStockHistory(stock) {

            this.submitted = true;
            this.activeTab = 2;
            this.stock = stock;

            console.log("[Applications][callStockHistory] this.stock = ", this.stock);

            try {
                const stockHistoryData = await StockHistoryService.getStockHistory(this.stock.exchange, this.stock.code)
                this.stockHistory = stockHistoryData.data;
                this.loading = false;

            } catch (e) {
                console.log("[" + name + "][callStockHistory] error = ", e);
                this.stockHistory = [];
            }

            console.log("[Applications][callStockHistory] this.stockHistory = ", this.stockHistory);
            this.submitted = false;
        },
        async callStockData(stock) {

            this.activeTab = 3;
            this.stock = stock;
            this.submitted = true;

            console.log("[Admin][callStockData] this.stock = ", this.stock);

            try {
                const stockDataInfo = await StockDataService.getSpecificStockDataForExchangeAndCode(this.stock.exchange, this.stock.code)
                this.stockData = stockDataInfo.data;
                console.log("[Applications][mounted] this.stockData = ", this.stockData);

                this.loading = false;

            } catch (e) {
                console.log("[" + name + "][callStockHistory] error = ", e);
                this.stockData = {};
            }

            this.submitted = false;

        }
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
